import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	fill: "#231F20",
	viewBox: "0 0 24 24",
	style: { enableBackground: "new 0 0 24 24" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(-1143.000000, -27.000000)",
		children: /* @__PURE__ */ _jsx("g", {
			transform: "translate(33.000000, 20.000000)",
			children: /* @__PURE__ */ _jsx("path", { d: "M1124.2,19l8.4,8.4c0.6,0.6,0.6,1.5,0,2.1l-0.1,0.1c-0.6,0.6-1.5,0.6-2.1,0l-8.4-8.4l-8.4,8.4 c-0.6,0.6-1.5,0.6-2.1,0l-0.1-0.1c-0.6-0.6-0.6-1.5,0-2.1l8.4-8.4l-8.4-8.4c-0.6-0.6-0.6-1.5,0-2.1l0.1-0.1 c0.6-0.6,1.5-0.6,2.1,0l8.4,8.4l8.4-8.4c0.6-0.6,1.5-0.6,2.1,0l0.1,0.1c0.6,0.6,0.6,1.5,0,2.1L1124.2,19z" })
		})
	})
});
export default SvgCloseIcon;
